import { useFormContext } from "react-hook-form";
import { ErrorMessage, TextInput, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { SignUpOperatorFormData } from "../types";

export const PlatformFitField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<SignUpOperatorFormData>();

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography variant="paragraph">Tell us in a few words what you hope the Rideminder software/platform will do for you personally and for your business?</Typography>
      <TextInput
        className="w-full"
        placeholder="Enter your answer"
        maxLength={255}
        hasError={!!errors.platformFit}
        {...register("platformFit")}
      />
      <ErrorMessage errors={errors} name="platformFit" />
    </div>
  );
};
